import axios from "@/utils/request";
import { snkd } from "@/api/api";

//获取农场信息

export const getFarmInfoService = (params) => {
  return axios.post(snkd.hsdt.getFarmInfo, params);
};
//获取当前农场的种养品种
export const onPlantingByFarmIdService = (params) => {
  return axios.post(snkd.hsdt.onPlantingByFarmId, params);
};

//生产统计
export const getMissionInfoService = (params) => {
  return axios.post(snkd.hsdt.getMissionInfo, params);
};

export const getAgriResSkuService = (params) => {
  return axios.post(snkd.hsdt.getAgriResSku, params);
};
